import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as RfqActions from "./actions";
import type { IRfqListReducerState } from "./types";

const initialRfqReducerState: IRfqListReducerState = {
  rfqList: [],
  isFetching: false,
  hasError: false
};

export default function rfqListReducer(state: IRfqListReducerState = initialRfqReducerState, action: ActionType<typeof RfqActions>): IRfqListReducerState {
  switch (action.type) {
    case getType(RfqActions.fetchRfqListStart):
      return { ...state, isFetching: true };

    case getType(RfqActions.fetchRfqListSuccess):
      return { ...state, isFetching: false, hasError: false, rfqList: action.payload };

    case getType(RfqActions.fetchRfqListFail):
      return { ...state, isFetching: false, hasError: true };

    default:
      return state;
  }
}
